import type { SerializedDockview } from 'dockview';

/** Check if the user has loaded the layout or if it is still the initial conversion from legacy market tabs */
export function isUntouchedMarketTabsImport(layout: SerializedDockview): boolean {
  // Check if the layout matches the initial default values
  // If the layout has been loaded the values will be different
  return (
    // First check against the first version of the default layout
    // Then check against the second version of the default layout
    (layout.grid.height === 900 &&
      layout.grid.width === 1600 &&
      layout.grid.root.size === undefined &&
      Array.isArray(layout.grid.root.data) &&
      layout.grid.root.data.length === 1 &&
      layout.grid.root.data[0].size === 1100 &&
      Array.isArray(layout.grid.root.data[0].data) &&
      layout.grid.root.data[0].data[0].size === 700 &&
      layout.grid.root.data[0].data[1].size === 200 &&
      Array.isArray(layout.grid.root.data[0].data[0].data) &&
      layout.grid.root.data[0].data[0].data[0].size === 370 &&
      layout.grid.root.data[0].data[0].data[1].size === 1100) ||
    (layout.grid.height === 900 &&
      layout.grid.width === 1600 &&
      layout.grid.root.size === 1100 &&
      Array.isArray(layout.grid.root.data) &&
      layout.grid.root.data.length === 2 &&
      layout.grid.root.data[0].size === 700 &&
      layout.grid.root.data[1].size === 200)
  );
}
